// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// import './pind_data.js'
import pind from './pind.js'
import './sha1'
// 入口中引用
import lang from '@51npm/vue-lang'
import filter from './common/filter'
Vue.use(lang, {
  defaultLang: '', // 默认语言
  page_url: 'CMS_front_249', // 翻译系统配置的页面链接
  app_key: 'CMS_front' // 翻译系统中的app_name
})
Vue.use(pind)
Vue.config.productionTip = false
Vue.use(filter)
router.beforeEach((to, from, next) => {
  // document.title = to.meta.title
  // console.log('from: ' + from.fullPath + ' to: ' + to.fullPath);
  next()
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js